import { ModuleWithProviders, NgModule } from '@angular/core';
import { Angulartics2Module } from 'angulartics2';

import { AnalyticsService } from './analytics.service';

import { ANALYTICS_CONFIG_TOKEN } from './analytics.token';

export interface BaseAnalyticsConfig {
  appName: string;
  appVersion: string;
  tenantTokenGetter?: () => string;
}

@NgModule({
  imports: [Angulartics2Module.forRoot()],
})
export class AnalyticsModule {
  static forRoot(
    config: BaseAnalyticsConfig,
  ): ModuleWithProviders<AnalyticsModule> {
    return {
      ngModule: AnalyticsModule,
      providers: [
        {
          provide: ANALYTICS_CONFIG_TOKEN,
          useValue: config,
        },
        AnalyticsService,
      ],
    };
  }
}
